var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"medium-modal modal"},[_c('div',{staticClass:"modal-main"},[_c('p',{staticClass:"modal-body"},[_c('span',[_vm._v("投稿された画像は二次利用される場合があります。それでもよろしいですか？")])]),_vm._v(" "),_c('button',{staticClass:"btn"},[_vm._v("投稿する")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e119ce6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/vue/PhotoConfirmModal.vue
// module id = null
// module chunks = 